import React from "react";
import styled from "styled-components";
import {subduedTextColour} from "../../../../style/styleConsts";
import {WarningContainer, WarningIcon} from "./WarningIcon";

export const CurrentRankColumn = styled.div`
    display: flex;
    justify-content: flex-end;
    font-size: 11px;
    text-transform: none;
    margin-right: 12px;
`;

export const CurrentRankRow = styled(CurrentRankColumn)`
    flex-direction: column;
`;

export const CurrentRankHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

const CurrentRankCellContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const CurrentRankCell = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    font-size: 11px;
`;

const RankText = styled.div`
    color: ${props => props.textColour};
`;

const CallToActionText = styled.div`
   font-size: 10px;
   color: #bd2d2d;
`;

const WarningWrapper = styled(WarningContainer)`
    margin-right: 3px;
`;

export const CurrentRank = ({kpi, rank: {rank, totalRanked}, actionToGetRanked}) => {
    let rankText;
    let callToActionText = null;
    if (!kpi) {
        rankText = "\u2014";
    } else if (!rank) {
        rankText = "Unranked";
        if (actionToGetRanked) {
            const {eligibility, other} = actionToGetRanked;
            if (eligibility) {
                callToActionText = <CallToActionText className="t-unrank-call-to-action-message">{eligibility}</CallToActionText>;
            } else {
                rankText = other;
            }
        }
    } else {
        rankText = `${rank}/${totalRanked}`;
    }

    const textColour = callToActionText ? "#bd2d2d" : kpi ? "black" :  subduedTextColour;
    const warningIconComponent = callToActionText ? <WarningIcon className="t-warning-unranked-icon">!</WarningIcon> : null;

    return <CurrentRankCellContainer>
        <WarningWrapper>{warningIconComponent}</WarningWrapper>
        <CurrentRankCell className="t-current-rank">
            <RankText textColour={textColour}>{rankText}</RankText>
            {callToActionText}
        </CurrentRankCell>
    </CurrentRankCellContainer>;

};
